module.exports = __webpack_public_path__ + "static/img/corrosion-0.4d7f937.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/corrosion-0.jpg
// module id = uJr+
// module chunks = 0